import type { TFunction } from "i18next";

import { UserGroup } from "../../utils/roles";
import type { NavigationUser } from "./types";

export const getUserGroupLabel = (user: NavigationUser | undefined, t: TFunction) => {
  const userGroup = user?.user_groups?.[0];

  // The backend is not consistent about casing, so match the group case-insensitively.
  return userGroup?.toLowerCase() === UserGroup.TRADER_REPR.toLowerCase()
    ? t("role.buyerRepresentative")
    : userGroup;
};
